<div class="col-md-12 text-center valign" *ngIf="healthy==='true'">
  <h2>Application is running</h2>
</div>
<div class="col-md-12 text-center valign" *ngIf="healthy==='false'">
  <h2>Application is not running</h2>
</div>
